<div class="error-message" *ngIf="establecimientoError">Selecciona un establecimineto</div>
<div class="ok-message fade-out" *ngIf="dispositivoCreado">El dispositivo se ha editado correctamente</div>
<div class="error-message fade-out" *ngIf="errorFinal">{{errorFinalMessage}}</div>

<ng-container *ngIf="errorMessage !== ''">
    <div class="error-container">
        <div class="mensaje-error-container">
            <div class="mensaje-error">{{ errorMessage }}</div>
            <mat-progress-bar mode="indeterminate" class="progress-bar" color="warn"></mat-progress-bar>
        </div>
    </div>
</ng-container>

<div class="container" *ngIf="errorMessage === ''">
    <div class="header">
        <div class="header-content">
            <span class="font20">VER DISPOSITIVO</span>
        </div>
        <span class="header-text font14">Formulario con los datos de dispositivo DataBeer</span>
    </div>
    <div class="body">

        <!--DISPOSITIVO-->
        <div class="datos-dispositivo">
            <div class="datos-dispositivo-header">
                <span>DATOS DEL DISPOSITIVO</span>
            </div>

            <mat-form-field class="etiqueta-container marginTop20" appearance="outline">
                <mat-label class="label-text">Nombre de Dispositivo</mat-label>
                <input matInput type="text" [(ngModel)]="etiqueta" placeholder="Nombre de una localidad, parroquia, nucleo, etc..." value="{{this.disopositivoActual.dev_label}}" readonly>
            </mat-form-field>

            <mat-form-field class="descripcion-container" appearance="outline">
                <mat-label class="label-text">Descripcion</mat-label>
                <textarea matInput type="text" [(ngModel)]="descripcion" placeholder="Situación actual del depósito" value="{{descripcion}}" readonly></textarea>
            </mat-form-field>

            <div class="estado-container marginTopM10">
                <span class="titulos-dispositivo">Estado: </span>
                <mat-form-field class="custom" appearance="outline">
                    <input matInput type="text" [(ngModel)]="selectedEstado" placeholder="Situación actual del depósito" value="{{selectedEstado}}" readonly>
                </mat-form-field>
            </div>

            <div class="referencia-container">
                <span class="titulos-dispositivo">Referencia: </span><span> Código DBXXX del dispositivo</span>
                <mat-form-field appearance="outline" class="latitud-value marginTop10">
                    <input matInput type="text" [readonly]="true" value={{disopositivoActual.dev_reference}}/>
                </mat-form-field>
            </div>

            <div class="token-container">
                <span class="titulos-dispositivo">Token de seguridad: </span><span> Cadena única de acceso seguro al dispositivo</span>
                <mat-form-field appearance="outline" class="latitud-value marginTop10">
                    <input matInput type="text" [(ngModel)]="tokenSeguridad" [readonly]="true" value={{tokenSeguridad}}/>
                </mat-form-field>
            </div>

            <mat-form-field class="etiqueta-container marginTop0" appearance="outline">
                <mat-label class="titulos-dispositivo">Nº de serie</mat-label>
                <input matInput type="text" [(ngModel)]="numSerie" placeholder="Ejemplo: VI1807160530V22" [readonly]="true">
            </mat-form-field>

            <mat-form-field class="etiqueta-container marginTop0" appearance="outline">
                <mat-label class="titulos-dispositivo">Nº SIM</mat-label>
                <input matInput type="text" [(ngModel)]="nSIM" placeholder="Ejemplo: 18071605300000 000 0" [readonly]="true">
            </mat-form-field>

            <mat-form-field class="etiqueta-container marginTop0" appearance="outline">
                <mat-label class="titulos-dispositivo">Versión</mat-label>
                <input matInput type="text" [(ngModel)]="version" placeholder="Versión del dispositivo" [readonly]="true">
            </mat-form-field>
        </div>
                
        <!--INSTALACION-->
        <div class="datos-instalacion">
            <div class="datos-instalacion-header">
                <span>DATOS DE LA INSTALACIÓN</span>
            </div>

            <div class="custom2">
                <span class="titulos-dispositivo">Establecimiento:</span>
                <mat-form-field class="widht100" appearance="outline">
                    <input matInput type="text" placeholder="Establecimiento del depósito" value="{{selectedEstablecimiento}}" readonly>
                </mat-form-field>
            </div>

            <div>
                <div class="marginBottom20">
                    <span class="custom3">Ubicación del establecimiento: </span>
                </div>
                <div id="map" class="height450"></div>
            </div>

            <div class="referencia-container marginTop20">
                <span class="custom3">Dirección completa: </span>
                <mat-form-field appearance="outline" class="latitud-value marginTop10" *ngIf="addressData">
                    <input matInput type="text" [readonly]="true" value="{{addressData}}"/>
                </mat-form-field>
                <mat-form-field appearance="outline" class="latitud-value marginTop10" *ngIf="!addressData">
                    <input matInput type="text" [readonly]="true" value="No hay datos disponibles"/>
                </mat-form-field>
            </div>

            <mat-form-field class="lat-container width48" appearance="outline">
                <mat-label class="label-text">Latitud</mat-label>
                <input matInput type="number" [(ngModel)]="lat" [readonly]="true" placeholder="Selecciona la latitud" value="{{lat}}">
            </mat-form-field>

            <mat-form-field class="lng-container custom6" appearance="outline">
                <mat-label class="label-text">Longitud</mat-label>
                <input matInput type="number" [(ngModel)]="lng" [readonly]="true" placeholder="Selecciona la latitud" value="{{lng}}">
            </mat-form-field>

            <div class="clientes-container">
                <span class="titulos-dispositivo">Cliente (Razón Social): </span>
                <mat-form-field class="custom7" appearance="outline">
                    <input matInput type="text" value="{{selectedCliente}}" readonly>
                </mat-form-field>
            </div>
        </div>
    </div>
</div>
<div class="footer"></div>
